// extracted by mini-css-extract-plugin
module.exports = {"bold":"FVSStep11AlertContent_bold__2e98t"};